import { Navigate, Outlet } from 'react-router-dom'
import { useEffect, useState } from 'react'
import { me } from './api'

export default function ProtectedRoute({ allowRoles }) {
  const [status, setStatus] = useState({ loading: true, ok: false })

  useEffect(() => {
    let alive = true
    me().then((res) => {
      if (!alive) return
      if (!res.authenticated) return setStatus({ loading: false, ok: false })
      const role = res.user.role
      setStatus({ loading: false, ok: allowRoles ? allowRoles.includes(role) : true })
    }).catch(() => setStatus({ loading: false, ok: false }))
    return () => { alive = false }
  }, [allowRoles])

  if (status.loading) return <div style={{padding:24}}>Cargando…</div>
  if (!status.ok) return <Navigate to="/" replace />
  return <Outlet />
}
